
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 1a8.336 8.336 0 00-8.334 8.333c0 4.6 3.733 8.334 8.333 8.334h4.167V16H9.999c-3.616 0-6.666-3.05-6.666-6.667 0-3.616 3.05-6.666 6.666-6.666 3.617 0 6.667 3.05 6.667 6.666v1.192c0 .658-.592 1.308-1.25 1.308s-1.25-.65-1.25-1.308V9.333c0-2.3-1.867-4.166-4.167-4.166a4.168 4.168 0 00-4.166 4.166 4.168 4.168 0 007.116 2.942c.542.742 1.475 1.225 2.467 1.225 1.642 0 2.917-1.333 2.917-2.975V9.333c0-4.6-3.734-8.333-8.334-8.333zm0 10.833a2.497 2.497 0 01-2.5-2.5c0-1.383 1.116-2.5 2.5-2.5 1.383 0 2.5 1.117 2.5 2.5 0 1.384-1.117 2.5-2.5 2.5z"}})])
          )
        }
      }
    